import { IApplicationState } from '../../types/redux';

export function selectAuthSocialLogin(state: IApplicationState) {
  return state.socialLogin.authSocialLogin;
}
